export default __webpack_public_path__ + "static/media/paws_up_banner.291a86ed.jpg";